import { render, staticRenderFns } from "./TextDetection.vue?vue&type=template&id=79d75bac&"
import script from "./TextDetection.vue?vue&type=script&lang=js&"
export * from "./TextDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports